<template>
    <div class="error-page">
        <h2>{{ error.statusCode }}</h2>
        <h3>{{ error.message }}</h3>
        <button @click="handleError">Return to Homepage</button>
    </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

const config = useRuntimeConfig();

useHead({
    title: 'Error | JetPark',
    meta: [
        {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1',
        },
        {
            name: 'robots',
            content: 'noindex, nofollow',
        },
    ],
    link: [{ rel: 'canonical', href: `${config.public.SITE_URL}/error` }],
});

const { error } = defineProps<{
    error: NuxtError;
}>();

if (import.meta.server) {
    console.error('Server-side error:', error);
} else {
    console.error('Client-side error:', error);
}

const handleError = () => {
    clearError();
    navigateTo('/', { external: true });
};
</script>

<style lang="postcss">
.error-page {
    @apply flex flex-col items-center justify-center h-screen bg-primary;
    h2 {
        @apply text-8xl font-bold text-gray-200 mb-4;
    }
    h3 {
        @apply text-4xl font-semibold text-gray-200 mb-8 max-w-[700px] text-center;
    }
    button {
        @apply px-4 py-2 bg-transparent border-white border-[4px] text-white hover:text-[#0d1c23] rounded-lg hover:bg-white transition duration-300;
    }
}
</style>
